import { Component, Input, ElementRef } from '@angular/core';

import { BaseWidget } from '../../../BaseWidget/BaseWidget.component';
import { NameValue } from '../../../../../interfaces/WidgetInterfaces';
import { DisplayStateService } from '../../../../../services/DisplayStateService';
import { AppStateService } from '../../../../../services/AppStateService';
import { WebPlatformApiService } from '../../../../../services/WebPlatformApiService';
import { ClientSettingsService } from '../../../../../services/ClientSettingsService';

@Component({
  selector: 'app-name-value-editor',
  template: `<div class="form-group row">
    <label class="col-sm-6 tightPad col-form-label">{{nameDisplay}}</label>
    <label class="col-sm-5 col-form-label">{{valueDisplay}}</label>
</div>
<div class="form-group row" *ngFor="let nv of nvArray; let idx = index">

    <div *ngIf="nameEnum; else nonameEnum" class="col-sm-3">
        <select class="form-control" [(ngModel)]="nv.name" id="nvName">
        <option *ngFor="let name of nameEnum" [ngValue]="name">
                {{name}}
        </option>
      </select>
    </div>
    <ng-template #nonameEnum>
        <div class="col-sm-3">
            <input type="text" class="form-control" [(ngModel)]="nv.name" name="name">
        </div>
    </ng-template>

    <div *ngIf="valueEnum; else novalueEnum" class="col-sm-5 tightPad">

        <select class="form-control" [(ngModel)]="nv.value" id="nvValue">
        <option *ngFor="let value of valueEnum" [ngValue]="value">
                {{value}}
        </option>
      </select>
    </div>

    <ng-template #novalueEnum>
        <div class="col-sm-5 tightPad">
            <input type="text" class="form-control" [(ngModel)]="nv.value" name="value">
        </div>
    </ng-template>

    <div class="col-sm-1 tightPad">
        <button type="button" class="btn btn-danger btn-sm" (click)="DeleteByIndex(idx)">
            <i class="fa fa-times"></i>
        </button>
    </div>
</div>
<button type="button" class="btn btn-sm btn-outline-primary" (click)="Add()">Add</button>`,
  styles: [``]
})
export class NameValueEditorComponent extends BaseWidget {

  @Input() nvArray: NameValue[];
  @Input() nameDisplay: string;
  @Input() valueDisplay: string;
  @Input() nameEnum: string[];
  @Input() valueEnum: string[];

  constructor(
    protected element: ElementRef,
    protected clientSettingsService: ClientSettingsService,
    protected displayStateService: DisplayStateService,
    protected appStateService: AppStateService,
    protected webPlatformApiService: WebPlatformApiService) {
      super(element, clientSettingsService, displayStateService, appStateService, webPlatformApiService);
    }
  Add() {
    this.nvArray.push({name: '', value: ''});
  }

  DeleteByIndex(idx) {
    this.nvArray.splice(idx, 1);
  }

}
